import styled from 'styled-components';

import { Waves as CommonWaves } from '~/src/common/components/Logo';
import { ProductGridArea } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/constants';
import { media } from '~/src/styles-constants';

export const Container = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-flow: column;
  grid-area: ${ProductGridArea.Details};
`;

export const Content = styled.div`
  position: relative;
  flex-grow: 1;
  bottom: 0;
  padding: 0 16px;

  ${media.M`
    padding: 0;
  `}
`;

export const Usage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  text-align: center;

  p {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: ${({ theme }) => theme.palette.common.BLACK};
    align-self: flex-start;
    text-align: left;
    margin: 0;

    path {
      fill: ${({ theme }) => theme.palette.common.PRIMARY_HOVER};
    }
  }
`;

export const Waves = styled(CommonWaves)`
  width: 100%;
  margin-bottom: 32px;
`;
